import './src/styles/global.css';
import './node_modules/sal.js/dist/sal.css';
import sal from 'sal.js';

sal();